import React, { lazy, Suspense } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../components/AuthView';

const AuthView = lazy(() => import('../components/AuthView'));

const ADMIN_EMAILS = ['paul@psaudio.com', 'mcgowan.paul1@gmail.com'];

const NAV_ITEMS = [
  { label: 'Control Center', path: '/ops/control-center' },
  { label: 'Release Checklist', path: '/ops/release-checklist' },
  { label: 'Admin', path: '/admin' },
  { label: 'Admin CC', path: '/admin/control-center' },
  { label: 'Devices', path: '/admin/devices' },
  { label: 'Diagnostics', path: '/admin/diagnostics' },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  const isAdmin = isAuthenticated && user?.email && ADMIN_EMAILS.includes(user.email);

  if (!isAuthenticated) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <Suspense fallback={<p style={{ color: '#888', fontSize: 15 }}>Loading…</p>}>
          <AuthView onAuthenticated={() => window.location.reload()} isModal={false} />
        </Suspense>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <p style={{ color: '#888', fontSize: 15 }}>Admin access required.</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {/* Top bar */}
      <header style={{
        height: 56,
        backgroundColor: '#1a1a2e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          <button
            onClick={() => navigate('/app')}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 8, padding: 0,
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span style={{ fontSize: 15, fontWeight: 800, color: '#C9A84C', letterSpacing: '-0.02em' }}>Maestro Ops</span>
          </button>

          <nav style={{ display: 'flex', gap: 4 }}>
            {NAV_ITEMS.map(item => {
              const active = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  style={{
                    background: active ? 'rgba(201,168,76,0.15)' : 'none',
                    border: 'none',
                    borderRadius: 8,
                    padding: '7px 14px',
                    fontSize: 13,
                    fontWeight: active ? 700 : 500,
                    color: active ? '#C9A84C' : 'rgba(255,255,255,0.55)',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                  }}
                >
                  {item.label}
                </button>
              );
            })}
          </nav>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 500 }}>
            {user?.email}
          </span>
        </div>
      </header>

      {/* Content */}
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '28px 24px 80px' }}>
        <Outlet />
      </main>
    </div>
  );
}
